import { resolveRetiredDirectWriteModel } from "../../../src/shared/retiredDirectWriteModels.js";
import { resolveWriteModelFallback } from "../../../src/shared/writeModelFallbacks.js";

/**
 * SW-9064: defaults helper for editor options stored in Firestore.
 *
 * Spell + grammar checks default to ON. For users who never touched
 * the toggle, the saved value is undefined/null — we treat that as
 * `true` at read time so existing users get the new default without a
 * data backfill. Users who explicitly opted out keep `false`.
 *
 * The language preference defaults to en-US when not set.
 */

export interface EditorOptionsLike {
  spellCheckEnabled?: boolean | null;
  grammarCheckEnabled?: boolean | null;
  languagePreference?: string | null;
  writeModel?: string | null;
  [key: string]: unknown;
}

export function applyEditorOptionDefaults<T extends EditorOptionsLike>(raw: T): T {
  const next: EditorOptionsLike = { ...raw };
  if (next.spellCheckEnabled === undefined || next.spellCheckEnabled === null) {
    next.spellCheckEnabled = true;
  }
  if (next.grammarCheckEnabled === undefined || next.grammarCheckEnabled === null) {
    next.grammarCheckEnabled = true;
  }
  if (typeof next.languagePreference !== "string" || !next.languagePreference) {
    next.languagePreference = "en-US";
  }
  if (typeof next.writeModel === "string") {
    next.writeModel = resolveRetiredDirectWriteModel(resolveWriteModelFallback(next.writeModel));
  }
  return next as T;
}
